/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import type { FlaggedReason } from "@packages/sdk";
import * as RadioGroup from "@radix-ui/react-radio-group";

import type { ThemeType } from "../../../../../global/emotion";
import { spacing } from "../../../../../global/emotion";
import { FLAG_RECORD_REASON_OPTIONS } from "../../../../lib/constants/flagRecordReasonOptions";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { FlagRecordReasonRadioInputItem } from "../FlagRecordReasonRadioInputItem/FlagRecordReasonRadioInputItem.emotion";

const rootStyle: Interpolation = {
  display: "flex",
  flexDirection: "column",
  gap: spacing.xxs,
};
const headerStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.neutralsMedium,
});

export const FlagRecordReasonRadioInput = ({
  value,
  onValueChange,
}: {
  value: FlaggedReason;
  onValueChange: (reason: FlaggedReason) => void;
}) => {
  const t = useTranslations();

  return (
    <>
      <Text type="title" size="m" css={headerStyle}>
        {t("community_flag_select_reason")}
      </Text>
      <RadioGroup.Root
        value={value}
        onValueChange={onValueChange}
        css={rootStyle}
      >
        {FLAG_RECORD_REASON_OPTIONS.map((option) => (
          <FlagRecordReasonRadioInputItem
            label={t(option.labelLokaliseKey)}
            sublabel={t(option.sublabelLokaliseKey)}
            value={option.value}
            checked={option.value === value}
            key={`flagRecordReason-${option.value}`}
          />
        ))}
      </RadioGroup.Root>
    </>
  );
};
